// extracted by mini-css-extract-plugin
export default {"sidebar":"_8yvgpr","highlighted-item":"_qroo16","highlightedItem":"_qroo16"};